//src\Components\RemovalShipmentDetails\RemovalShipmentDetails.tsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { downloadDocuments, uploadDocument } from "../Helper/DocumentsHelper";
import UploadFileBtn from "../Helper/UploadFileBtn/UploadFileBtn";
import "../Shipment/Shipment.scss";
import { DocumentsTypes } from "../Enum/DocumentsType";
import DataGridTamplet from "../Helper/TableTemplet/DataGridTamplet";
import { GridRenderCellParams } from "@mui/x-data-grid";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import RemovalShipmentUtils from "./RemovalShipmentUtils";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IconButton } from "@material-ui/core";

const RemovalShipmentDetails = () => {
  const { t } = useTranslation("RemovalShipmentDetails");
  const dispatch = useDispatch();

  const columns = [
    { field: "order_id", headerName: t("removal_order_id"), width: 165 },
    {
      field: "shipment_date",
      headerName: t("shipment_date"),
      width: 150
    },
    {
      field: "tracking_number",
      headerName: t("tracking_number"),
      width: 160
    },
    {
      field: "order_details",
      headerName: t("order_details"),
      editable: true,
      width: 140
    },
    {
      field: "actions",
      headerName: " ",
      width: 85,
      renderCell: (params: GridRenderCellParams) => (
        <Button
          variant="outlined"
          size="small"
          className="blue-outlined-btn"
          tabIndex={params.hasFocus ? 0 : -1}
          onClick={() => updateOrderDetails(params.id, params.row.order_details)}
        >
          {t("save")}
        </Button>
      ),
    },
    {
      field: "document_upload",
      headerName: t("document_upload"),
      width: 290,
      renderCell: (params: GridRenderCellParams) => (
        <Box sx={{ transform: "scale(0.9)" }}>
          <UploadFileBtn
            id={params.id}
            onSubmit={importDocument}
            multiple={false}
            index={params.id}
            title=""
            fileType={"imageAndPdf"}
            buttonText={t("upload")}
            autoUpload={true}
          ></UploadFileBtn>
        </Box>
      ),
    },
    {
      field: "document_download",
      headerName: t("document_download"),
      width: 170,
      cellClassName: "justify-center",
      renderCell: (params: GridRenderCellParams) => {
        const count = params.row?.documents?.length ?? 0;
        const disabled = count === 0;

        return (
          <Box display="flex" alignItems="center" gap={1}>
            <IconButton
              size="small"
              onClick={() => download(params)}
              disabled={disabled}
              aria-label={t("document_download")}
            >
              <DownloadOutlinedIcon />
            </IconButton>

            <Box
              component="span"
              style={{
                fontSize: 12,
                opacity: disabled ? 0.5 : 1,
                whiteSpace: "nowrap",
              }}
            >
              {t("fileCount", { count })}
            </Box>
          </Box>
        );
      },
    }
  ];

  const updateOrderDetails = async (removalOrderID, orderDetails) => {
    if (!orderDetails) {
      alert(t("missing_order_details"));
    } else {
      await RemovalShipmentUtils.updateOrderDetails(
        dispatch, defaultAccount.id, removalOrderID, orderDetails);
    }
  };

  const download = async (item) => {
    try {
      const count = item?.row?.documents?.length ?? 0;

      if (count > 0) {
        await downloadDocuments(dispatch, defaultAccount.id, "removal", null, item.id);
      } else {
        alert(t("no_documents"));
      }
    } catch (error) {
      alert(error);
    }
  };


  const defaultAccount = useSelector(
    (state: any) => state.account.default_account
  );
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (defaultAccount && defaultAccount.id) {
      getRemovalShipments();
    }
  }, [defaultAccount]);

  const getRemovalShipments = async () => {
    setItems(await RemovalShipmentUtils.getRemovalShipments(dispatch, defaultAccount.id));
  };

  const importDocument = async (file, id = null, index) => {
    const uploadedDocs = await uploadDocument(
      dispatch,
      file,
      DocumentsTypes.REMOVAL_SHIPMENT,
      defaultAccount.id,
      null,
      index,
      id
    );

    setItems(prev =>
      prev.map((row: any) => {
        if (row.id !== id) return row;

        return {
          ...row,
          documents: [
            ...(row.documents ?? []),
            ...(Array.isArray(uploadedDocs) ? uploadedDocs.slice(-1) : [])
          ]
        };
      })
    );
  };


  return (
    <div className="shipment">
      <h2>{t("title")}</h2>
      <DataGridTamplet
        columns={columns}
        rows={items}
      />
    </div>
  );
};

export default RemovalShipmentDetails;
